/*
* 個人情報の取扱いについての同意スクロール監視
*/
import ConsentApi from '@js/modules/consentApi/index';

export default class PrivacyConsentScroll {
  attachEvent() {
    const privacyContent = document.querySelector('.privacy-consent-content');
    const privacyCheckbox = document.querySelector('.privacy-consent-checkbox');

    if (!privacyContent || !privacyCheckbox) return;

    // 既に同意済みかチェック
    const isAlreadyConsented = privacyCheckbox.checked;

    // 初期状態設定
    privacyCheckbox.disabled = !isAlreadyConsented;
    const label = privacyCheckbox.closest('label');
    if (label) label.style.opacity = isAlreadyConsented ? '1' : '0.7';

    // 同意済みでない場合のみスクロール監視を設定
    if (!isAlreadyConsented) {
      // コンテンツの高さチェック（スクロール不要な場合は即座に有効化）
      if (privacyContent.scrollHeight <= privacyContent.clientHeight + 10) {
        privacyCheckbox.disabled = false;
        if (label) label.style.opacity = '1';
      } else {
        // スクロールが必要な場合のみスクロール監視を設定
        privacyContent.addEventListener('scroll', function() {
          if (this.scrollTop + this.clientHeight >= this.scrollHeight - 10) {
            privacyCheckbox.disabled = false;
            if (label) label.style.opacity = '1';
          }
        });
      }
    }

    // チェックボックス変更時の処理（常にイベントリスナーをアタッチ）
    privacyCheckbox.addEventListener('change', () => {
      const isChecked = privacyCheckbox.checked;

      // 同意済みでない場合のみDB保存
      if (isChecked && !isAlreadyConsented) {
        this.savePrivacyConsent();
      }

      // 状態変更を明示的に通知（チェック・アンチェック両方）
      document.dispatchEvent(new CustomEvent('consent:changed', {
        detail: {
          type: 'privacy',
          consented: isChecked,
          element: privacyCheckbox
        }
      }));
    });
  }

  // プライバシー同意をDBに保存（ConsentApiを使用）
  savePrivacyConsent() {
    ConsentApi.savePrivacyConsent();
  }
}
